export default "__VITE_ASSET__qf0S8tPq__"